import { Options } from './types'
import { deepCopy, getSessionId } from '../utils'

let globalOptions: Options
let originalOptions: Options

function initOptions(options: Options) {
  if (!options) {
    throw new Error('options 不能为空')
  }
  originalOptions = options
  globalOptions = deepCopy(options)

  initSessionOptions()
  initPvOptions()

  if (!globalOptions.beforeReport) {
    globalOptions.beforeReport = () => undefined
  }
}

function initSessionOptions() {
  const { sessionId } = globalOptions
  if (typeof sessionId === 'function') {
    // sessionId为function时直接调用
    globalOptions.sessionId = sessionId()
  }
  if (!globalOptions.sessionId) {
    // 默认生成一个uuid为sessionId
    globalOptions.sessionId = getSessionId()
  }
}

function initPvOptions() {
  // 默认开启路由监测
  let route = true
  // 默认周期性上报为30s一次
  let interval = 30000
  const opts = globalOptions.pv
  if (opts === false) {
    // globalOptions.pv 显式指定为false的情况下，不上报pv信息
    route = false
    interval = 0
  } else if (opts && typeof opts === 'object') {
    // 以对象方式传入配置项时， route或者interval不传视为默认
    if (opts.hasOwnProperty('route')) {
      route = opts.route
    }
    if (opts.hasOwnProperty('interval')) {
      interval = opts.interval
    }
  }
  globalOptions.pv = { route, interval }
}

export {
  globalOptions,
  originalOptions,
  initOptions
}
